import { ConfigType, LocaleInterface, AdminTypes, PersonType } from 'types'

export type ContextType = {
  config?: ConfigType
  locale?: LocaleInterface
}

export type PersonInfoType = {
  person: PersonType
  paymentPurchasers: PaymentPurchaserType[]
}

export enum AdministratorsExportFormats {
  XLSX = 'XLSX',
}

export interface AdministratorType extends PersonType {
  administratorType?: AdminTypes
  orgAccountId?: string
}

export type Administrators = {
  administrators: PersonType[]
}

export type PersonAdminInfoType = {
  personFirstName: string
  personLastName: string
  orgKimId?: number

  organizations: Array<{
    orgNumber: string
    orgName: string
    orgAdmin: boolean
    orgKimId?: number

    orgAccounts: Array<{
      orgKimId?: number
      orgAccountId: string
      orgAccountName: string
      mainAccount: boolean
      accountAdmin: boolean
      administratorType: AdminTypes
    }>
  }>
}

export type OrgAccountType = {
  orgAccountId?: string
  orgKimId?: number
  orgNumber?: string
  orgName?: string
  foodCompany?: boolean
  orgAccountName?: string
  orgAccountStatus?: OrgAccountStatus
  administrators?: AdministratorType[]
  signatories?: PersonType[]
  applicant?: PersonType
  effectivePurchaseLimit?: number
  bookedAmount?: number
  reservedAmount?: number
  blocked?: boolean
  organizationAvailableAmount?: number
}

export enum OrgAccountStatus {
  NEW = 'NEW',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type InvoiceRecipientType = {
  orgAccountId?: string
  invoiceRecipientId?: string
  name: string
  recipientName: string
  addressRow1: string
  addressRow2?: string
  zipCode: string
  city: string
  countryCode: string
  customerRef1?: string
  customerRef2?: string
  reference?: string
  contractReference?: string
  status: InvoiceRecipientStatus
  invoiceDeliveryMethod?: InvoiceDeliveryMethods
  // TODO: Add more config types & intermediators when implemented
  invoiceDeliveryConfig?: InvoiceDeliveryConfigType
  invoicingFrequency?: InvoiceFrequencyTypes
  invoiceGrouping: InvoiceGroupingTypes
}

type InvoiceDeliveryConfigType = {
  intermediator?: string
  addresseeId?: string
  invoiceEmail?: string
}

export enum Countries {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
  XK = 'XK',
}

export interface InvoiceRecipientAdminApiType extends PersonType {
  engagements: string[]
}

export enum InvoiceGroupingTypes {
  PER_TRANSACTION = 'PER_TRANSACTION',
}

export enum InvoiceRecipientStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum InvoiceDeliveryMethods {
  EINVOICE_B2B = 'EINVOICE_B2B',
  MAIL_INVOICE = 'MAIL_INVOICE',
  PRINT_INVOICE = 'PRINT_INVOICE',
}

export enum Intermediators {
  TIETO = 'TIETO',
  ADDETT = 'ADDETT',
  BWEI = 'BWEI',
  LOGICA = 'LOGICA',
  LOGIQ = 'LOGIQ',
  CLIENTCOMP = 'CLIENTCOMP',
  CREDIFLOW = 'CREDIFLOW',
  EDB = 'EDB',
  EXPSYS = 'EXPSYS',
  HANDSESS = 'HANDSESS',
  INEXCHANGE = 'INEXCHANGE',
  ITELLA = 'ITELLA',
  ITELLAFI = 'ITELLAFI',
  NDEASESS = 'NDEASESS',
  PAGERO = 'PAGERO',
  PALETTE = 'PALETTE',
  ESSESESS = 'ESSESESS',
  STRALFORS = 'STRALFORS',
  SWEDSESS = 'SWEDSESS',
  PROCEEDO = 'PROCEEDO',
  PEAB = 'PEAB',
  PEPPOL = 'PEPPOL',
  APIX = 'APIX',
  IBX = 'IBX',
  EASYLINK = 'EASYLINK',
  TRUEC = 'TRUEC',
  ENCODE = 'ENCODE',
  GLOBALEDI = 'GLOBALEDI',
  HDATA = 'HDATA',
  INTEGRS = 'INTEGRS',
  KNOWE = 'KNOWE',
  KMD = 'KMD',
  LIAS = 'LIAS',
  NEXMART = 'NEXMART',
  PIPECH = 'PIPECH',
  PRIHANDEL = 'PRIHANDEL',
  SATA = 'SATA',
  TELEMA = 'TELEMA',
  TELIA = 'TELIA',
  TELIASONERA = 'TELIASONERA',
  VISMA = 'VISMA',
  VISMASNO = 'VISMASNO',
  VISMASPCS = 'VISMASPCS',
  VISMAUAS = 'VISMAUAS',
}

export enum InvoiceFrequencyTypes {
  ONE_PER_MONTH = 'ONE_PER_MONTH',
  TWO_PER_MONTH = 'TWO_PER_MONTH',
}

export type PaymentPurchaserType = {
  orgAccountId: string
  invoiceRecipientId: string
  invoiceRecipientName: string
  status: PaymentPurchaserStatus
  purchaseLimit: number
  purchaserFirstName: string
  purchaserLastName: string
  purchaserPersonalId: string
  purchaserId: string
  purchaserPersonId: string
  purchaserKimId: number
}

export enum PaymentPurchaserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING_CARD_TOKEN = 'PENDING_CARD_TOKEN',
}

export enum PaymentPurchasersExportFormats {
  XLSX = 'XLSX',
}

export type PurchaserPersonMapType = {
  [kimId: number]: PurchaserPersonType
}

export type PurchaserPersonType = {
  purchaserKimId: string
  purchaserFirstName: string
  purchaserLastName: string
  purchaserPersonalId: string
  invoiceRecipients: [
    {
      purchaserId: string
      invoiceRecipientId: string
      invoiceRecipientName: string
      purchaseLimit: number
      status: PaymentPurchaserStatus
      // @ts-ignore
    }
  ]
}

export enum TransactionsExportFormats {
  XLSX = 'XLSX',
  ODS = 'ODS',
}

export type TransactionsListType = {
  transactions: TransactionSummaryType[]
  totalNumberFiltered: number
  pagesTotal?: number
}

export type TransactionSummaryType = {
  transactionGuid: string
  transactionTs: string
  totalPaymentAmount: string
  totalPaymentAmountExclVat: string
  totalVatAmount: string
  transactionType: 'SALES' | 'RETURN'
  storeName: string
  kimId: string
  purchaserName: string
  invoiceRecipientId: string
  invoiceRecipientName: string
  invoiced: string
}

export type TransactionType = {
  transactionGuid: string
  transactionId: {
    sessionId: string
    kossStoreId: string
    terminalId: number
    receiptNbr: number
    transactionSequenceNbr: number
    salesReportUuid: string
    transactionTs: string
  }
  persistedTs: string
  totalPaymentAmount: string
  totalPaymentAmountExclVat: string
  totalVatAmount: string
  totalVat: TransactionVatLineType[]
  payment: TransactionPaymentType
  transactionType: 'SALES' | 'RETURN'
  storeInfo: {
    storeLedgerId: string
    ownerLedgerId: string
    storeName: string
  }
  itemStatus: 'OK' | 'ITEMS_WITH_WARNINGS'
  purchaserInfo: {
    fimPersonId: string
    kimId: number
    firstName: string
    lastName: string
    paymentPurchaserId: string
    invoiceRecipientId: string
    invoiceRecipientName: string
    orgAccountId: string
    orgNumber: string
  }
  lineItems: TransactionItemType[]
  invoiced: boolean
  invoiceId: string
  invoicedTs: string | null
}

type TransactionVatLineType = {
  vatAmount: string
  vatRate: string
  amountExclVat: string
  amountInclVat: string
}

export type TransactionPaymentType = {
  authorizationUuid: string
  purchaserToken: string
  expirationDateYyMm: string
  keyName: string
  encryptionType: string
}

export type DiscountItems = Array<{
  discountAmount: string
  discountDescription: string
}>

export type TransactionItemType = {
  sequenceNo: number
  salesItem: {
    salesType: 'SALES' | 'RETURN'
    isCanceled: boolean
    itemIdentities: Array<{
      identityType: 'EAN' | 'PLU'
      identityId: string
    }>
    shortName: string
    merchandiseHierarchy: {
      level: string
      id: number
    }
    quantity: string
    salesUnit: TransactionSalesItemSalesUnit
    listPrice: string
    salesPrice: string
    taxPercentage: string
    taxAmount: string
    isDiscountable: boolean
    isLoyaltyEligible: boolean
    isEnvironmentType: boolean
    discountItems: DiscountItems
  }
  tenderItem: {
    tenderType: 'INVOICE'
    tenderAmount: string
    invoiceToken: string
  }
}

export enum TransactionSalesItemSalesUnit {
  STK = 'STK',
  L = 'L',
  KG = 'KG',
  HG = 'HG',
  M = 'M',
}

export enum InvoiceStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  INVOICED = 'INVOICED',
  REMINDER = 'REMINDER',
  COLLECTION = 'COLLECTION',
}

export type InvoiceSpecificationSummary = {
  id: string
  invoiceRecipientId: string
  invoiceRecipientName?: string
  orgAccountId: string
  ownerLedgerId: string
  status: InvoiceStatus
  invoiceDate?: string
  preferredDueDate?: string
  invoiceSequenceNumber?: string
  invoiceTotalAmount?: string
  invoiceTotalVat?: string
  amountToPay?: string
  discountedAmountToPay?: string
  discountedInvoiceTotalAmount?: string
  discountedInvoiceTotalVat?: string
}

export type InvoicesListType = {
  invoices: InvoiceSpecificationSummary[]
  totalNumberFiltered: number
}

export type InvoiceSpecification = {
  id: string
  invoiceRecipientId: string
  ownerLedgerId: string
  orgAccountId: string
  status: InvoiceStatus
  invoiceSequenceNumber?: string
  invoiceDate?: string
  preferredDueDate?: string
  purchaseItems?: PurchaseItem[]
  feeItems?: FeeItem[]
  customerInfo?: CustomerInfo
  amountInfo?: AmountInfo
  cusinRef?: string
  ownerFeeSpecificationRef?: string
}

export type PurchaseItem = {
  transactionGuid: string
  transactionTs: string
  storeName: string
  purchaserFirstName: string
  purchaserLastName: string
  terminalId: number
  receiptNbr: number
  amountExclVat?: string
  amountInclVat: string
  vatAmount?: string
  vatLines?: VatLine[]
}

export type VatLine = {
  vatRate?: string
  vatAmount: string
  amountExclVat?: string
  amountInclVat?: string
  discountableAmountExclVat?: string
  discountedAmountExclVat?: string
  discountedAmountInclVat?: string
  discountedVatAmount?: string
}

export type FeeItem = {
  feeId: string
  feeType: FeeType
  feeName: string
  amountExclVat: string
  amountInclVat: string
  vatAmount: string
  vatRate: string
}

export enum FeeType {
  CUSTOMER_SERVICE_FEE = 'CUSTOMER_SERVICE_FEE',
  CUSTOMER_DELIVERY_FEE = 'CUSTOMER_DELIVERY_FEE',
}

export type CustomerInfo = {
  invoiceRecipientName: string
  invoiceCustomerNo: number
  orgNumber: string
  orgKimId: string
  addressName: string
  addressRow1: string
  addressRow2?: string
  zipCode: string
  city: string
  customerRef1?: string
  customerRef2?: string
  reference?: string
  distributionChoice: string
}

export type AmountInfo = {
  invoiceTotalAmount: string
  invoiceTotalVat: string
  amountToPay: string
  amountInfoVatLines?: VatLine[]
  discountedAmountToPay?: string
  discountedTotalAmount?: string
  discountedTotalVat?: string
}

export type StatisticsType = {
  count: number
  sum?: number
  max?: number
  avg?: number
  last?: number
  items: StatisticItemType[]
}

export type StatisticItemType = {
  id: string
  label: string
  value: number
}

export enum FormActionType {
  CREATING,
  UPDATING,
  VIEWING,
}
